(() => {
  const root = document.getElementById('MrPurchaseToast');
  const dataNode = document.getElementById('MrPurchaseToastData');
  if (!root || !dataNode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let data;
  try {
    data = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }

  const products = Array.isArray(data.products) ? data.products.filter((item) => item && item.title) : [];
  if (!products.length) return;

  const cities = String(data.cities || '')
    .split(',')
    .map((city) => city.trim())
    .filter(Boolean);
  const gap = Math.max(8, Number(data.interval) || 12) * 1000;
  const visibleFor = 6500;

  const link = root.querySelector('[data-toast-link]');
  const image = root.querySelector('[data-toast-image]');
  const label = root.querySelector('[data-toast-label]');
  const title = root.querySelector('[data-toast-title]');
  const closeButton = root.querySelector('[data-toast-close]');

  let lastIndex = -1;
  let hideTimer;
  let loopTimer;
  let dismissed = false;

  const pick = (list) => list[Math.floor(Math.random() * list.length)];

  const nextProduct = () => {
    if (products.length === 1) return products[0];
    let index = Math.floor(Math.random() * products.length);
    if (index === lastIndex) index = (index + 1) % products.length;
    lastIndex = index;
    return products[index];
  };

  const messageFor = (product) => {
    const minutes = pick([1, 2, 3, 4, 5, 8, 12]);
    const people = pick([3, 4, 5, 6, 7, 8, 9, 11]);
    const city = pick(cities.length ? cities : ['Lahore']);
    const templates = [
      `Someone just purchased this product`,
      `This product was purchased ${minutes} minute${minutes === 1 ? '' : 's'} ago`,
      `Someone from ${city} just purchased this product`,
      `${people} people purchased this product recently`,
    ];
    return pick(templates);
  };

  const hide = () => {
    root.classList.remove('is-visible');
    hideTimer = window.setTimeout(() => {
      root.hidden = true;
    }, 280);
  };

  const show = () => {
    if (dismissed) return;
    const product = nextProduct();
    label.textContent = messageFor(product);
    title.textContent = product.title;
    link.href = product.url || '#';
    if (product.image) {
      image.src = product.image;
      image.hidden = false;
    } else {
      image.removeAttribute('src');
      image.hidden = true;
    }
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-visible'));
    hideTimer = window.setTimeout(hide, visibleFor);
  };

  const cycle = () => {
    if (dismissed) return;
    show();
    loopTimer = window.setTimeout(cycle, gap);
  };

  closeButton?.addEventListener('click', () => {
    dismissed = true;
    window.clearTimeout(hideTimer);
    window.clearTimeout(loopTimer);
    hide();
  });

  root.addEventListener('mouseenter', () => window.clearTimeout(hideTimer));
  root.addEventListener('mouseleave', () => {
    if (!dismissed && root.classList.contains('is-visible')) {
      hideTimer = window.setTimeout(hide, 1800);
    }
  });

  window.setTimeout(cycle, 4000);
})();
